import {Component, OnInit} from '@angular/core';
import {CookieConsentService} from "@shared/services/cookie-consent.service";
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'ui-organism-cookie-banner',
  standalone: true,
  imports: [
    TranslatePipe
  ],
  templateUrl: './ui-organism-cookie-banner.component.html',
  styleUrl: './ui-organism-cookie-banner.component.scss'
})
export class UiOrganismCookieBannerComponent implements OnInit {
  // Indica si el banner debe mostrarse o no
  protected showBanner = true;

  constructor(private cookieConsentService: CookieConsentService) {
  }

  ngOnInit(): void {
    // Mostramos el banner solo si el usuario no ha dado consentimiento todavía
    this.showBanner = !this.cookieConsentService.hasConsent();
  }

  // Acepta el uso de cookies y oculta el banner
  acceptCookies(): void {
    this.cookieConsentService.setConsent();
    this.showBanner = false;
  }
}
